const menu = {
    label: 'Testemunhas',
    icon: 'pi pi-fw pi-users',
    to: '/mapaparceiros/testemunhas',
    rules: ['MAPAPARC-PAR-00'],
};

export default menu;